import {compute, create, signal} from "@targoninc/jess";
import {currentPage} from "../lib/state.ts";

export function backToTop() {
    const showButton = signal(false);

    const onScroll = (e: Event) => {
        const target = e.target as HTMLElement;
        showButton.value = target.scrollTop > 300;
    };

    const attachScrollListener = () => {
        const content = document.querySelector(".content-wrapper");
        if (content) {
            content.addEventListener("scroll", onScroll);
        }
    };

    currentPage.subscribe(() => {
        showButton.value = false;
        setTimeout(attachScrollListener, 500);
    });

    const scrollToTop = () => {
        const content = document.querySelector(".content-wrapper");
        if (content) {
            content.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };

    return compute((show) => {
        return create("button")
            .classes("back-to-top", show ? "show" : "")
            .onclick(scrollToTop)
            .children(
                create("span")
                    .classes("material-symbols-outlined")
                    .text("arrow_upward")
                    .build()
            )
            .build();
    }, showButton);
}
